<template>
    <div class="relative-article">
        <div class="box box-align-center ra-top">
            <div class="rat-txt flex">
                <div v-if="required" style="color: #F56C6C; padding-right: 4px;">*</div>
                选择{{ title }}：
            </div>
            <el-button type="primary" plain icon="el-icon-plus" @click="() => chooseVisible = true">选{{ title
                }}</el-button>
        </div>
        <div class="ra-table">
            <dy-table :columns="columns" :table-data="tableData" ref="fbTable" v-loading="tableLoading"
                :isShowPager="false" element-loading-text="加载中"></dy-table>
        </div>
        <el-dialog v-if="chooseVisible" :title="`选择${title}`" :visible.sync="chooseVisible" append-to-body width="80%"
            :close-on-click-modal="false">
            <resourceCommon :type="type" :title="title" :columns="_columns" @close-dialog="() => chooseVisible = false"
                @saveData="saveData" :list="this.tableData" :max="max">
            </resourceCommon>
        </el-dialog>
    </div>
</template>
<script>
import DyTable from '@/components/common/dytable'
import resourceCommon from './resourceCommon'

export default {
    components: {
        DyTable,
        resourceCommon
    },
    props: {
        type: {
            type: Number,
            default: 0,
        },
        title: {
            type: String,
            default: "选择",
        },
        list: {
            type: Array,
            default: () => [],
        },
        required: {
            type: Boolean,
            default: false,
        },
        max: {
            type: Number,
            default: 0,
        },
    },
    watch: {
        list(newVal, oldVal) {
            this.tableData = newVal;
        }
    },

    data() {
        return {
            tableLoading: true,
            columns: [],
            tableData: [],
            total: 100,

            chooseVisible: false,
            arTableLoading: true,
            _columns: [],
            arTableData: [],
            arTotal: 100,
        }
    },
    created() {
        let col = []
        if (this.type == 0) {
            col = [
                {
                    key: 'resourceId',
                    title: '视频ID'
                },
                {
                    key: 'resourceName',
                    title: '视频名称'
                },
                {
                    key: 'resourceCategoryName',
                    title: '视频分类'
                }
            ]
        } else {
            col = [
                // {
                //     key: 'resourceId',
                //     title: `${this.title}ID`
                // },
                {
                    key: 'resourceName',
                    title: `资源名称`
                },
                {
                    key: 'resourceCategoryName',
                    title: `资源分类`
                },
                {
                    key: 'resourceType',
                    title: `资源类型`
                },
            ];
        }

        this.columns = [
            {
                type: 'index',
                title: '序号',
            },
            ...col,
            {
                key: '',
                title: '操作',
                render: ({ row }) => {
                    return (
                        <div>
                            <el-link type="danger" onClick={() => this.delItem(row)} >删除</el-link>
                        </div>
                    );
                }
            },
        ];
        this._columns = [
            ...col,
            {
                key: 'updateDate',
                title: '上传时间'
            },
        ];

    },
    mounted() {
        this.tableLoading = false;
        this.arTableLoading = false;

    },
    methods: {
        onCurrentChange(val) {
            // console.log(val);
        },

        saveData(arr) {
            this.tableData = arr || this.tableData;
            this.$emit('saveData', {
                type: this.type,
                data: this.tableData
            });
        },

        //删除数据
        delItem(row) {
            let index = this.tableData.findIndex(item => item.resourceId == row.resourceId);
            this.tableData.splice(index, 1);
            this.saveData();
        },
    }
}
</script>
<style scoped>
.ra-table {
    margin-top: 12px;
    margin-bottom: 22px;
}
</style>